const buyLocationOptions = [
	{ value: "https://brick.me", label: "North America" },
	{ value: "https://uk.brick.me", label: "Europe" },
	{ value: "https://au.brick.me", label: "Rest of the World" },
];

export default buyLocationOptions;
